"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSummaryPricing = exports.getStudioSummary = void 0;
const core_1 = require("@natomas-org/core");
const getStudioSummary = (product, structure, additionalItemPriceInMicros, priceMode) => {
    const selectedModifiers = getAllStudioSelectedModifiers(structure);
    const pricing = (0, exports.getSummaryPricing)(product, selectedModifiers, additionalItemPriceInMicros, priceMode);
    const orderSummary = Object.assign({ product: product, structure: structure, selectedModifiers: selectedModifiers }, pricing);
    return orderSummary;
};
exports.getStudioSummary = getStudioSummary;
/*
 * The structure is already filtered by validity,
 * so we only need to filter all modifiers against selections
 * */
const getAllStudioSelectedModifiers = (activeStructure) => {
    const selectedModifiers = [];
    activeStructure === null || activeStructure === void 0 ? void 0 : activeStructure.forEach((category) => {
        var _a;
        (_a = category === null || category === void 0 ? void 0 : category.selectedModifierGroups) === null || _a === void 0 ? void 0 : _a.forEach((modifierGroup) => {
            selectedModifiers.push(...modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.selectedModifiers);
        });
    });
    return selectedModifiers;
};
const getSummaryPricing = (product, selectedModifiers, additionalItemsTotalInMicros, priceMode) => {
    var _a, _b;
    let upgradePrice = { cost: 0, price: 0, currency: "USD" };
    let upgradesInMicros = 0;
    // Total upgrades
    selectedModifiers.forEach((modifier) => {
        var _a;
        upgradesInMicros += (0, core_1.getMicrosForPriceMode)(modifier, priceMode);
        const adjustedPrice = (_a = modifier === null || modifier === void 0 ? void 0 : modifier.adjustedPrice) !== null && _a !== void 0 ? _a : {
            price: modifier === null || modifier === void 0 ? void 0 : modifier.adjustedPriceMicros,
            cost: 0,
            currency: "USD",
        };
        upgradePrice = core_1.Price.sumPrices(upgradePrice, adjustedPrice);
    });
    // Format pricing
    const priceOptions = { excludeInventoryUpgrades: true };
    const unitPrice = {
        cost: (_a = core_1.Product.getUnitCost(product, priceOptions)) !== null && _a !== void 0 ? _a : 0,
        price: (_b = core_1.Product.getUnitPrice(product, priceOptions)) !== null && _b !== void 0 ? _b : 0,
        currency: "USD",
    };
    // TODO This does not account for additional line item costs!!!!
    // const unitAdditionalItemsTotal: IPrice = {
    //   cost: 0,
    //   price: additionalItemsTotalInMicros,
    //   currency: "USD",
    // };
    // Get total unit price
    const totalUnitPrice = core_1.Price.sumPrices(unitPrice, upgradePrice
    // unitAdditionalItemsTotal
    );
    return {
        upgradesInMicros: upgradesInMicros,
        upgradePrice: upgradePrice,
        additionalItemsTotalInMicros: additionalItemsTotalInMicros,
        totalUnitPrice: totalUnitPrice,
    };
};
exports.getSummaryPricing = getSummaryPricing;
//# sourceMappingURL=summary.js.map